<template>
    <div class="artcile_main">

 <div class="about-box">
    <div class="box1">
      <div class="title2">
        <div class="title-left">
          <span>热门网站</span>
        </div>
        <div class="title-right">
          <a href="https://www.cs2club.cn/articleInfo?articleId=267" target="_blank" class="article-ad-link">
            <span>广告屏蔽和翻译</span>
          </a>
        </div>
      </div>
      <el-row
        :gutter="15"
        class="site-cards"
        style="margin-left: 0px; margin-right: 0px"
      >
        <el-col
          :xs="6"
          :sm="6"
          :md="3"
          :lg="3"
          :xl="3"
          v-for="site in recommendedData"
          :key="site.id"
          class="site-card"
        >
          <div class="site-card-content">
            <div class="site-image">
              <a
                :href="site.url"
                target="_blank"
                style="text-decoration: none; color: inherit"
              >
                <img :src="site.thumb" class="site-image-square"
              /></a>
            </div>
            <div class="site-info">
              <a
                :href="site.url"
                target="_blank"
                :class="'item3 site-link'"
                class="site-title"
              >
                {{ site.title }}</a
              >
              <!-- <p class="site-title">hltv</p> -->
            </div>
          </div>
        </el-col>
      </el-row>


    </div>
  </div>
  

        <!-- <div class="title">
            <span>最新文章</span>
        </div> -->
        <div class="mainBox">
            <div class="tabs-container">
                <div class="scroll-button left" @click="scrollLeft" v-show="showLeftArrow">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <el-tabs v-model="activeTab" class="article-tabs" @tab-click="handleTabClick">
                    <el-tab-pane label="全部" name="all">
                        <ul class="ul_item" v-for="item in filteredArticleList" :key="item.id">
                            <li class="main_li wow bounceIn" @click="handleClick(item.id)" data-wow-duration="2s"
                                data-wow-iteration="1">
                                <div class="thumbnail">
                                    <img class="article_cover" :src="getImageUrl(item.avatar)" :alt="item.title" @error="item.avatar = img" />
                                    <i class="iconfont icon-tupian"></i>
                                    <span class="time">{{ item.createTime }}</span>
                                </div>
                                <div class="information">
                                    <div class="titleName">
                                        <span v-if="item.isStick == 1" class="top">置顶</span>
                                        {{ item.title }}
                                    </div>
                                    <div class="info">
                                        {{ item.summary }}
                                    </div>
                                    <div class="meta">
                                        <ul class="items">
                                            <li>
                                                <i class="far fa-user" style="color: #409eff"></i>
                                                {{ item.username }}
                                            </li>
                                            <li>
                                                <i class="far fa-calendar" style="color:#fb6c28 "></i>
                                                {{ item.createTime }}
                                            </li>
                                            <li>
                                                <!-- <i class="iconfont icon-yuedu"></i> -->
                                                <i class="far fa-eye" style="color: #67C23A"></i>
                                                {{ item.quantity }}</li>
                                        </ul>
                                        <ul class="items">
                                            <li v-for="tag in item.tagList" :key="tag.id">
                                                <i class="iconfont icon-biaoqian"></i>
                                                <!-- <i class="far fa-tag"></i> -->
                                                <span class="tag_name">{{ tag.name }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane v-for="category in categories" :key="category.id" :label="category.name" :name="String(category.id)">
                        <ul class="ul_item" v-for="item in filteredArticleList" :key="item.id">
                            <li class="main_li wow bounceIn" @click="handleClick(item.id)" data-wow-duration="2s"
                                data-wow-iteration="1">
                                <div class="thumbnail">
                                    <img class="article_cover" :src="getImageUrl(item.avatar)" :alt="item.title" @error="item.avatar = img" />
                                    <i class="iconfont icon-tupian"></i>
                                    <span class="time">{{ item.createTime }}</span>
                                </div>
                                <div class="information">
                                    <div class="titleName">
                                        <span v-if="item.isStick == 1" class="top">置顶</span>
                                        {{ item.title }}
                                    </div>
                                    <div class="info">
                                        {{ item.summary }}
                                    </div>
                                    <div class="meta">
                                        <ul class="items">
                                            <li>{{ item.username }}</li>
                                            <li>{{ item.createTime }}</li>
                                            <li><i class="iconfont icon-yuedu"></i>{{ item.quantity }}</li>
                                        </ul>
                                        <ul class="items">
                                            <li v-for="tag in item.tagList" :key="tag.id">
                                                <i class="iconfont icon-biaoqian"></i>
                                                <span class="tag_name">{{ tag.name }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
                <div class="scroll-button right" @click="scrollRight" v-show="showRightArrow">
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getRecommendedList } from "@/api/site";
import { featchCategory, fetchArticleList } from "@/api";
export default {
    name: 'articleList',
    props: {
        articleList: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            recommendedData: [],
            img: "https://cdn.cs2club.cn/error.png",
            activeTab: 'all',
            categories: [],
            showLeftArrow: false,
            showRightArrow: true,
            pageData: {
                pageNo: 1,
                pageSize: 6,
                categoryId: null
            },
            localArticleList: []
        }
    },
    computed: {
        filteredArticleList() {
            return this.localArticleList;
        }
    },
    watch: {
        articleList: {
            immediate: true,
            handler(newVal) {
                this.localArticleList = newVal;
            }
        }
    },
    mounted() {
        new this.$wow.WOW().init();
        this.checkScrollButtons();
        window.addEventListener('resize', this.checkScrollButtons);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScrollButtons);
    },
    created() {

        this.getRecommended();
        this.getCategories();
        this.getArticleList();
    },
    methods: {
        getImageUrl(url) {
            if (!url) return '';
            // 检查URL是否已经包含压缩参数
            if (url.includes('-zip')) return url;

            // 如果URL不包含问号，添加问号
            return url + '-zip';
        },
        getRecommended() {
            getRecommendedList()
                .then((res) => {
                    this.recommendedData = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCategories() {
            featchCategory().then(res => {
                this.categories = res.data;
            }).catch(err => {
                console.log(err);
            });
        },
        getArticleList() {
            fetchArticleList(this.pageData).then(res => {
                this.localArticleList = res.data.records;
            }).catch(err => {
                console.log(err);
            });
        },
        formatDate: function (value, args) {
            var dt = new Date(value);
            let year = dt.getFullYear();
            let month = (dt.getMonth() + 1).toString().padStart(2, '0');
            let date = dt.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${date}`;
        },
        handleClick(id) {
            this.$router.push({ path: '/articleInfo', query: { articleId: id } })
        },
        handleTabClick(tab) {
            this.activeTab = tab.name;
            this.pageData.categoryId = tab.name === 'all' ? null : Number(tab.name);
            this.pageData.pageNo = 1;
            this.getArticleList();
        },
        getArticlesByCategory(categoryId) {
            return this.localArticleList.filter(article => {
                return article.categoryId === categoryId;
            });
        },
        scrollLeft() {
            const tabsContainer = document.querySelector('.article-tabs');
            tabsContainer.scrollLeft -= 200;
            this.checkScrollButtons();
        },
        scrollRight() {
            const tabsContainer = document.querySelector('.article-tabs');
            tabsContainer.scrollLeft += 200;
            this.checkScrollButtons();
        },
        checkScrollButtons() {
            const tabsContainer = document.querySelector('.article-tabs');
            if (tabsContainer) {
                this.showLeftArrow = tabsContainer.scrollLeft > 0;
                this.showRightArrow = tabsContainer.scrollLeft < (tabsContainer.scrollWidth - tabsContainer.clientWidth);
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.el-card.is-always-shadow {
  box-shadow: 0px 0px 20px -5px rgba(158, 158, 158, 0.27);
}
.site-cards {
  margin-top: -10px;
  // border: 1px solid #ebeef5; /* 设置边框的粗细和颜色 */
  padding: 2px; /* 设置边框内部的内边距 */
  //  border-radius: 10px;
}

.site-card {
  margin-top: 15px;
}

.site-card-content {
  border-radius: 10px;
  background: linear-gradient(to bottom, var(--background-color), var(--background-color-secondary));
  padding: 2px 0px 5px 0px;
  // box-shadow: 0px 0px 20px -5px rgba(158,158,158,0.27)
}

.site-image {
  text-align: center;
}

.site-image-square {
  width: 55px;
  height: 55px;
  border-radius: 10px;
}

.site-info {
  text-align: center;
}

.site-title {
  font-size: 15px;
//   font-weight: bold;
  font-weight: 700;
  margin-top: 0px;
}
.about-box .box1 {
  .title1 {
    width: 100%;
    height: 45px;
    padding-left: 10px;
    color: var(--theme-color);
    position: relative;
    // border-bottom: 1px solid var(--border-line);

    span {
      display: inline-block;
      font-size: 14px;
      line-height: 45px;
      font-weight: 700;
    }
  }
  .title2 {
    width: 100%;
    height: 45px;
    padding: 0 0 0 15px;
    color: var(--theme-color);
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .title-left {
      span {
        display: inline-block;
        font-size: 14px;
        line-height: 35px;
        font-weight: 700;
      }
    }

    .title-right {
      .article-ad-link {
        text-decoration: none;
        color: inherit;
        margin-right: 10px;
        span {
          display: inline-block;
          font-size: 14px;
          line-height: 35px;
          font-weight: 700;
        }
      }
    }
  }
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 将行数改为1 */
  -webkit-box-orient: vertical;
}
.el-card ::v-deep .el-card__header {
  padding: 4px 10px 4px 10px;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}
.el-card ::v-deep .el-card__body {
  padding-top: 5px;
  padding-bottom: 10px;
  height: 54px;
  // padding-left: 15px;
  // padding-right: 8px
}
.custom-table .el-table__row {
  height: 200px !important; /* 调整为所需的行高 */
  line-height: 200px !important; /* 与 height 值保持一致，用于垂直居中内容 */
}
.el-card {
  border: none;
  background-color: #fff;
}
@media screen and (max-width: 890px) {
    .artcile_main {
        background-image: var(--article-bg-image);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-color: var(--background-color);
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--background-color);
            opacity: 0.92;
            z-index: 0;
        }
        > * {
            position: relative;
            z-index: 1;
        }
        margin-left: 7px;
        margin-right: 7px;
        .title {
            width: 100%;
            height: 45px;
            padding-left: 10px;
            color: var(--theme-color);
            position: relative;
            border-bottom: 1px solid var(--border-line);

            span {
                display: inline-block;
                font-size: 14px;
                line-height: 45px;
                font-weight: 700;
            }
        }

        .mainBox {
            width: 100%;
            .ul_item {
                width: 100%;
                padding-left: 5px;
                cursor: pointer;
                border-bottom: 1px solid var(--border-line);

                &:last-child {
                    border: 0;
                }

                .main_li {
                    list-style: none;
                    display: flex;
                    position: relative;
                    padding-bottom: 18px;
                    margin-top: 18px;
                    width: 100%;


                    .thumbnail {
                        flex-shrink: 0;
                        position: relative;
                        width: 150px;
                        height: 120px;
                        margin-right: 15px;
                        overflow: hidden;
                        text-decoration: none;

                        .article_cover {
                            border-radius: 4px;
                            object-fit: cover;
                            width: 100%;
                            height: 100%;
                        }

                        .iconfont {
                            position: absolute;
                            top: 2px;
                            left: 5px;
                            color: var(--background-color);
                            font-size: 18px;
                        }

                        .time {
                            display: none;
                        }
                    }

                    .information {
                        display: flex;
                        -webkit-box-orient: vertical;
                        -webkit-box-direction: normal;
                        -ms-flex-direction: column;
                        flex-direction: column;
                        -webkit-box-flex: 1;
                        -ms-flex: 1;
                        flex: 1;
                        min-width: 0;
                        width: 100%;

                        .titleName {
                            margin-bottom: 10px;
                            color: var(--article-color);
                            font-size: 1.2em;
                            line-height: 24px;
                            max-height: 72px;
                            -webkit-transition: color .35s;
                            transition: color .35s;
                            text-decoration: none;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            white-space: normal;
                            width: 100%;
                            .top,
                            .original {
                                display: none;
                            }
                        }

                        .info {
                            display: none;
                        }

                        .meta {
                            -webkit-box-pack: justify;
                            -ms-flex-pack: justify;
                            justify-content: space-between;
                            margin-top: auto;
                            color: var(--text-color);
                            font-size: 13px;
                            -webkit-box-align: center;
                            -ms-flex-align: center;
                            align-items: center;
                            width: 100%;

                            .items {
                                -webkit-box-pack: start;
                                -ms-flex-pack: start;
                                justify-content: flex-start;
                                -ms-flex-negative: 0;
                                flex-shrink: 0;
                                -webkit-box-align: center;
                                -ms-flex-align: center;
                                align-items: center;
                                padding: 0 0;
                                width: 100%;

                                li {
                                    list-style: none;
                                    display: inline-block;

                                    &:after {
                                        content: "/";
                                        color: #c0c4cc;
                                        padding: 0 0px;
                                    }

                                    &:last-child:after {
                                        content: "";

                                    }

                                    i {
                                        padding: 0 3px;
                                        font-size: 13px;
                                    }

                                    .tag_name {
                                        color: var(--text-color);
                                        text-decoration: none;
                                        width: 100%;

                                        &:hover {
                                            cursor: pointer;
                                            color: var(--theme-color);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .title2 {
          .article-ad-link {
            margin-right: 10px;
            
            span {
              font-size: 12px;
            }
          }
        }

    }
}

@media screen and (min-width: 891px) {
    .artcile_main {
        background-image: var(--article-bg-image);     
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--background-color);
            opacity: var(--background-opacity, 0.85);
            z-index: 0;
        }
        > * {
            position: relative;
            z-index: 1;
        }
        .title {
            width: 100%;
            height: 45px;
            color: var(--theme-color);
            position: relative;
            border-bottom: 1px solid var(--border-line);
            margin-left: 15px;

            span {
                display: inline-box;
                font-size: 14px;
                line-height: 45px;
                font-weight: 700;
            }
        }

        .ul_item {
            padding-left: 20px;
            cursor: pointer;
            border-bottom: 1px solid var(--border-line);

            &:last-child {
                border: 0;
            }

            &:hover {
                .article_cover {
                    transform: scale(1.2);
                }

                .time {
                    transform: translateX(-110%) translateY(5%);
                    transition: all 0.5s;
                }

                .main_li .information .titleName,
                .main_li .information .info {
                    color: var(--theme-color);
                }

                .main_li::before {
                    transform: scaleX(1);
                }

            }

            .main_li {
                list-style: none;

                display: flex;
                position: relative;
                padding-bottom: 18px;
                margin-top: 18px;



                &::before {
                    content: "";
                    width: 4px;
                    height: 30px;
                    background-color: var(--theme-color);
                    position: absolute;
                    left: -15px;
                    border-radius: 50px;
                    transform: scaleX(0);
                    transition: all 0.5s;
                }

                .thumbnail {
                    flex-shrink: 0;
                    position: relative;
                    width: 210px;
                    height: 140px;
                    margin-right: 15px;
                    overflow: hidden;
                    text-decoration: none;

                    .article_cover {
                        border-radius: 4px;
                        object-fit: cover;
                        width: 100%;
                        height: 100%;
                        transition: all 0.3s;
                    }

                    .iconfont {
                        position: absolute;
                        top: 2px;
                        left: 5px;
                        color: var(--background-color);
                        font-size: 18px;
                    }

                    .time {
                        display: block;
                        padding: 5px 5px;
                        border-radius: 20px;
                        position: absolute;
                        font-size: 12px;
                        top: 3px;
                        right: -38%;
                        background-color: var(--theme-color);
                        color: var(--background-color);
                    }
                }

                .information {
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    min-width: 0;

                    .titleName {
                        margin-bottom: 10px;
                        color: var(--article-color);
                        font-size: 1.2em;
                        line-height: 24px;
                        max-height: 48px;
                        -webkit-transition: color .35s;
                        transition: color .35s;
                        text-decoration: none;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 100%;
                        font-weight: 600;
                        .top,
                        .original {
                            height: 20px;
                            padding: 0 6px;
                            // margin-right: 5px;
                            line-height: 20px;
                            font-size: 12px;
                            white-space: nowrap;
                            vertical-align: 2px;
                            color: var(--background-color);

                            border-radius: 2px 6px;
                            display: inline-block;
                        }

                        .top {
                            font-size: 14px;
                            background-image: -webkit-linear-gradient(0deg, #3ca5f6 0, #a86af9 100%);
                        }

                        .original {
                            background-image: -webkit-linear-gradient(0deg, #26A69A 0, #00897B 100%);
                        }
                    }

                    .info {
                        color: var(--text-color);
                        // line-height: 22px;
                        // max-height: 44px;
                        // opacity: .85;
                        // text-decoration: none;
                        // width: 100%;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;

                  
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
                    }

                    .meta {
                        -webkit-box-pack: justify;
                        -ms-flex-pack: justify;
                        justify-content: space-between;
                        margin-top: auto;
                        color: var(--text-color);
                        font-size: 13px;
                        display: flex;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;

                        .items {
                            -webkit-box-pack: start;
                            -ms-flex-pack: start;
                            justify-content: flex-start;
                            -ms-flex-negative: 0;
                            flex-shrink: 0;
                            display: flex;
                            -webkit-box-align: center;
                            -ms-flex-align: center;
                            align-items: center;
                            padding: 0 0;

                            li {
                                list-style: none;
                                display: inline-block;

                                &:after {
                                    content: "/";
                                    color: #c0c4cc;
                                    padding: 0 0px;
                                }

                                &:last-child:after {
                                    content: "";

                                }

                                i {
                                    padding: 0 3px;
                                    font-size: 13px;
                                }

                                .tag_name {
                                    color: var(--text-color);
                                    text-decoration: none;

                                    &:hover {
                                        cursor: pointer;
                                        color: var(--theme-color);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

    }
}

.tabs-container {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 10px;
}

.article-tabs {
    flex: 1;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
}

.scroll-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background-color: var(--theme-color);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
    &.left {
        left: 0;
    }
    &.right {
        right: 0;
    }
    &:hover {
        opacity: 0.8;
    }
}

::v-deep .el-tabs__header {
    margin-top:5px;
    margin-left: 10px;
    margin-right: 10px;
    // height: 45px;
    border-bottom: none;
    // padding-left: 10px;
}

::v-deep .el-tabs__nav {
    border: none;
}

::v-deep .el-tabs__nav-wrap.is-scrollable.is-top::after {
    height: 1px;
    background-color: var(--border-line);
}

::v-deep .el-tabs__item {
    font-size: 15px;
    line-height: 45px;
    // font-weight: 700;
    color: var(--text-color);
    padding: 0 15px;
    &.is-active {
        color: var(--theme-color);
    }
}

::v-deep .el-tabs__active-bar {
    background-color: var(--theme-color);
}

::v-deep .el-tabs__item.is-active {
    font-weight: 700;
}


@media screen and (min-width: 891px) {
  .site-link {
    text-decoration: none;
    white-space: nowrap;
    color: var(--site-color);
  }
}

@media screen and (max-width: 890px){
  .site-link {
    text-decoration: none;
    white-space: nowrap;
    color: var(--site-color);
  }
}


</style>